import BENEFICIARY_SUBJECT_TYPE_KEY from '@Domain/Subjects/BeneficiarySubjectTypeKey';

/** Identifies a dossier: the key of its type plus its identifier. */
class SubjectAddress {
	constructor(
		public readonly typeKey: string,
		public readonly subjectId: number,
	) {
		Object.freeze(this);
	}

	get isBeneficiary(): boolean {
		return this.typeKey === BENEFICIARY_SUBJECT_TYPE_KEY;
	}

	static forBeneficiary(beneficiaryId: number): SubjectAddress {
		return new SubjectAddress(BENEFICIARY_SUBJECT_TYPE_KEY, beneficiaryId);
	}
}

export default SubjectAddress;
